
import { Component, Mixins, Watch } from "vue-property-decorator";
import SideMenuLayout from "@/views/sidebar/side-menu-layout.vue";
import NotificationMixin from "@/views/sidebar/notification/notification.mixin";
import BaseMixin from "@/views/base/base.mixin";
import { 
  NotificationTypeDDL, 
  AssessmentDto,
  SendTypeDDL,
  SendTypes 
} from "@/views/sidebar/notification/notification.type";
import { ErrorBag, Field } from "vee-validate";

type SideMenuLayoutInstance = InstanceType<typeof SideMenuLayout>;

@Component({
  components: {
    "side-menu-layout": SideMenuLayout
  }
})
export default class SendNotificationComponent extends Mixins(NotificationMixin, BaseMixin) {
  assessmentDto: AssessmentDto = new AssessmentDto();

  loading = false;
  alertVisible = false;
  customText = "";
  alertMessage = "";
  alertVariant = "success";

  veeFields!: Field;
  veeErrors!: ErrorBag;

  get showSendType() {
    return (
      this.selectedNotificationTypeDDL.value > 0 && 
      !this.selectedNotificationType.isAssessment &&
      this.selectedNotificationType.id
    );
  }

  get showPhoneSection() {
    return (
      this.selectedNotificationTypeDDL.value > 0 && 
      (this.selectedNotificationType.isAssessment ||
      this.selectedSendTypeDDL.value == SendTypes.PHONE)
    );
  }

  get showCustomText() {
    return (
      this.selectedNotificationTypeDDL.value > 0 && 
      !this.selectedNotificationType.id
    );
  }

  get isWatch() {
    return (
      this.selectedNotificationTypeDDL.value > 0 && 
      (!this.selectedNotificationType.isAssessment &&
      this.selectedSendTypeDDL.value == SendTypes.WATCH)
    );
  }

  async mounted() {
    this.loading = true;
    this.assessmentDto.phoneNumber = this.$sidebar.state?.item.phoneNumber;
    await this.fetchData();
    this.loading = false;
  }

  async fetchData() {
    await this.$store.dispatch("Notification/fetchNotificationTypes", this.selectedClientDDL.value);
  }

  async onNotificationTypeSelect(notificationTypeDDL: NotificationTypeDDL) {
    this.customText = "";
    this.$store.commit("Notification/updateField", {
      path: "selectedNotificationTypeDDL",
      value: notificationTypeDDL
    });
  }

  async onSendTypeSelect(sendTypeDDL: SendTypeDDL) {
    this.$store.commit("Notification/updateField", {
      path: "selectedSendTypeDDL",
      value: sendTypeDDL
    });
  }

  sendAssessment() {
    this.$validator.validateAll().then(async (isValid: boolean) => {
      if (isValid) {
        this.loading = true;
        if (this.isWatch) {
          await this.$store.dispatch("Notification/sendNotification", {
            participantId: this.$sidebar.state?.item.participantId,
            surveyId: this.selectedNotificationType.id,
            clientId: this.selectedClientDDL.value,
          });
        } else {
          var phone = this.assessmentDto.phoneNumber.replace(/\D/g, '');
          if (this.selectedNotificationType.isAssessment) {
            await this.$store.dispatch("Notification/createAssessment", {
              patientId: this.$sidebar.state?.item.patientId,
              assessmentType: this.selectedNotificationType.id,
              triggerType: 1,
              phoneNumber: phone,
              clientId: this.selectedClientDDL.value,
            });
          } else if (!this.selectedNotificationType.id && this.showCustomText) {
            await this.$store.dispatch("Notification/sendSmsNotification", {
              phoneNumber: phone,
              clientId: this.selectedClientDDL.value,
              message: this.customText.trim()
            });
          } else {
            await this.$store.dispatch("Notification/createAssessment", {
              patientId: this.$sidebar.state?.item.patientId,
              assessmentType: 0, // all surveys are 0
              triggerType: 1,
              phoneNumber: phone,
              clientId: this.selectedClientDDL.value,
              surveyId: this.selectedNotificationType.id
            });
          }
        }
        this.loading = false;
        if (!this.errorMessage) {
          this.$sidebar.close( {success: true, reload: true} );
        } else {
          (this.$refs.sideMenu as SideMenuLayoutInstance).showAlert();
        }
     }
    });
  }

  validateState(ref: keyof Field) {
    if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || 
        this.veeFields[ref].validated)
    ) {
        return !this.veeErrors.has(ref);
    }
    return null;
  }
}
